import { render, staticRenderFns } from "./WalletTransactions.vue?vue&type=template&id=199da900&scoped=true"
import script from "./WalletTransactions.vue?vue&type=script&lang=js"
export * from "./WalletTransactions.vue?vue&type=script&lang=js"
import style0 from "./WalletTransactions.vue?vue&type=style&index=0&id=199da900&prod&scoped=true&lang=css"
import style1 from "./WalletTransactions.vue?vue&type=style&index=1&id=199da900&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199da900",
  null
  
)

export default component.exports